import createSelectDropdown from './create-select-dropdown';
import i18n from '@/natives/libs/i18n';
import { LANGUAGE_OPTIONS, INDEX_TO_KEY } from '@pro/common/consts/language-options';
import useEventBus from '@/natives/libs/hooks/useEventBus';

let selectDropdown;

function handleChange(index) {
  localStorage.setItem('hik_connect_pro_locale', index);
  const languageChange = useEventBus('language-change');
  languageChange.emit(index);
  window.location.reload();
}

let langs = [];
let defaultLang = i18n.locale;
if (process.env.appmode === 'CUSTOMIZE') {
  langs = ['ja'];
  if (!langs.includes(i18n.locale)) {
    defaultLang = 'ja';
    i18n.locale = defaultLang;
  }
}
/**
 * mounted
 */
(function () {
  const container = document.getElementById('select-language');
  const options = langs.length
    ? LANGUAGE_OPTIONS.reduce((acc, cur) => {
      if (langs.includes(cur.key)) {
        console.log(cur);
        acc.push({
          ...cur,
          label: i18n.t(cur.label)
        });
      }
      return acc;
    }, [])
    : LANGUAGE_OPTIONS.map((item) => ({
      ...item,
      label: i18n.t(item.label)
    }));
  selectDropdown = createSelectDropdown(container, options);
  selectDropdown.select(INDEX_TO_KEY[defaultLang]);
  selectDropdown.on('select', handleChange);
})();
